import { EnvConfiguration } from '../config/EnvConfiguration';

// Marks a viewer URL as having come from a scanned Care Code, so arriving that way can be told
// apart from an ordinary view-only share link. Survives the session exchange, which strips only
// the token param.
export const VIEWER_SOURCE_PARAM = 'src';
export const CARE_CODE_SOURCE = 'care-code';

export class ViewerUrlProvider {
    static inject = () => [EnvConfiguration];
    constructor(private config: EnvConfiguration) {}

    /**
     * careMapId sends the viewer straight to that care recipient's care profile. Without it the
     * app picks the landing page itself once the session is exchanged, so pass it whenever the
     * destination matters. The app only applies its own redirect when the hash doesn't already
     * name the care map, so an explicit destination survives the session exchange.
     */
    buildViewerUrl = ({ access_token, careMapId, source }: { access_token: string; careMapId?: string; source?: string; }) => {
        const sourceParam = source ? `&${VIEWER_SOURCE_PARAM}=${encodeURIComponent(source)}` : '';
        const destination = careMapId ? `#/care/${careMapId}` : '';
        return `${this.config.WEB_BASE_URL}/?v=${access_token}${sourceParam}${destination}`;
    };
};
